(function() { module.exports = window["wc"]["wcSettings"]; }());